import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select } from '@ngrx/store';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subscription } from 'rxjs';
import { HeadersFacade } from '../../../../domain/facades/facades';
import { CART_DISPLAY_STATUS_SELECTOR } from '../../../../domain/facades/store/HeaderThemes.selectors';
import { SET_REDIRECT_ACTION, UPDATE_AUTH_MODAL_STATUS_ACTION, UPDATE_CART_DISPLAY_STATUS_ACTION } from '../../../../domain/facades/store/HeaderThemes.actions';
import { BaseComponent, LanguageService, WebsiteAttributesService } from 'imakeapp-shared';
import { CartFacade } from 'imakeapp-cart';




@Component({
  selector: 'app-quick-cart-theme1',
  templateUrl: './theme1.component.html',
  styleUrls: ['./theme1.component.scss'],
  animations: [
    trigger('transactionAnimation', [
      transition('start => end', [
        style({ transform: 'scale(1)' }),
        animate('500ms', style({ transform: 'scale(1.5)' }))
      ]),
    ]),  trigger('fadeOutAnimation', [
      transition(':leave', [
        animate('500ms', style({ opacity: 0 }))
      ])
    ])

  ]
})
export class QuickCartTheme1Component extends BaseComponent implements OnInit ,OnDestroy
{



  public animationState: boolean[] = [];;
  showQuickCart: boolean = false;
  cart_total: number = 0;
  cart_list: any[] = [];
  isLoading: boolean = false;
  isNotFound: boolean = false;


  constructor(
    private store: Store,
    private router: Router,
    private cookie_s: CookieService,
    private cartFacades: CartFacade,
    private headersFacade:HeadersFacade,
    public override language_s: LanguageService,
    public Websiteservice: WebsiteAttributesService,


  ) {
    super(language_s,Websiteservice);

    this.Websiteservice.get_site_attributes().subscribe(
      (response : any)=>{
console.log(response)

      },
      (err)=>{
        console.error(err);
      }
    );
  }



 override ngOnInit(): void
  {
     super.ngOnInit()
     this.toggle_cart();
     this.get_cart_items();
     this.get_cart_total();
     console.log("gg")
  }










  toggle_cart()
  {

    this.subscriptions?.push( this.store.pipe(select(CART_DISPLAY_STATUS_SELECTOR)).subscribe(
      (response)=>{
console.log(response)
        this.showQuickCart = response!;

      }
    ),


   this.cartFacades.LoadingCart$.subscribe(
      (response)=>{

        this.isLoading = response;

      }
    ));


  }


  get_cart_items()
  {
    this.cartFacades.RequestCart()
    this.cartFacades.FetchCart$.subscribe(
      (cart_list)=>{

        this.cart_list = cart_list;
        console.log(this.cart_list)
        this.isNotFound = this.cart_list.length ==  0

      }
    );

  }


  redirect()
  {

console.log(this.attributesObject.signin_require_order)
    // check if user signed-in
    if ( this.cookie_s.get('user') || this.attributesObject.signin_require_order == 0)
    {

      this.router.navigateByUrl('/shopping/checkout');

      this.store.dispatch( new UPDATE_CART_DISPLAY_STATUS_ACTION(false) );

    }
    else
    {
      this.store.dispatch( new UPDATE_CART_DISPLAY_STATUS_ACTION(false) );
     this.store.dispatch( new SET_REDIRECT_ACTION('checkout') );
this.headersFacade.ShowSignInModal()
console.log("else")
    }


  }



  hideCart()
  {

    this.store.dispatch(new UPDATE_CART_DISPLAY_STATUS_ACTION(false) );

  }





  delete_cart_item(cart_item: any)
  {
    //cart_item.state = 'inactive';

    this.cartFacades.delete_cart_item(cart_item?.id)
  }


  get_cart_total()
  {


    this.subscriptions?.push( this.cartFacades.CART_TOTAL$.subscribe(
      (cart_total)=>{
        this.cart_total = cart_total;
      }
    ))

  }
  updateAmount(item: any, amount: any, index: number) {
    debugger

    if (amount <= 0) {
      this.cartFacades.delete_cart_item(item.id);
    } else {
      this.cartFacades.update_cart_item(item.id, amount);
      this.cart_list[index].amount = amount;
    }
  }

}
